import { AgencyService } from './../api/agency.service';
import { OnInit, Component, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Agent, WebPage } from '../models/index';
import { OpenModalService } from './shared/modals/open-modal.service';
import { BaseComponent } from './base-component';

@Component({
  selector: 'app-about-us-base',
  template: ''
})

export class AboutUsBaseComponent extends BaseComponent implements OnInit {
  agents: Agent[] = [];
  webPage: WebPage;

  constructor(
    injector: Injector,
    public agencyService: AgencyService,
    public route: ActivatedRoute,
    private openModalService: OpenModalService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.route.data.forEach((data: { agents: Agent[], web_page: WebPage }) => {
      this.validateRouteDataParams(data, ['agents', 'web_page']);
      this.agents = data.agents;
      this.webPage = data.web_page;

      this.setTitle('Despre ' + this.agencyService.agency.name);
      this.setMetaDescription(this.webPage.html);
    });
  }

  openAgentModal(agent: Agent): void {
    this.openModalService.showDetailsModal(agent.full_name, agent.job, agent.description, agent.avatar);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/about-us-base.component.ts